import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { CreditFragment } from '@/pages/graphql/fragments/TitleDetails.fragment';

import { SnowplowPersonContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { CollectionType } from '@/enums/collection-type';

import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useRouter } from 'vue-router/composables';
import { isEditorialLocale } from '@/routing/editorial';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleCreditName',
  props: {
    credit: null
  },
  setup(__props: any) {

const props = __props as {
	credit: CreditFragment;
};



const router = useRouter();

const userStore = useUserStore();
const filterStore = useFilterStore();
const languageStore = useLanguageStore();

const profileRoute = computed(() => {
	return {
		name: isEditorialLocale(languageStore.webLocale) ? 'app.user.author' : '',
		path: props.credit?.profilePath,
	};
});

function clicked({ searchString, personId }: { searchString?: string; personId?: number }) {
	TrackingHelper.trackEvent(
		'persons_credit_name',
		{
			action: 'clicked',
			label: props.credit?.role,
			property: `${personId}`,
		},
		// credit prop sets a non-null default value but TS isn't catching it (Vue 2)
		[new SnowplowPersonContext(personId!, searchString!)]
	);

	if (!props.credit?.profilePath) {
		userStore.saveSearchTerm(searchString);
		const newRoute = filterStore.updateRouterState({
			collectionType: CollectionType.SEARCH,
			routeQuery: { q: searchString, person_id: personId },
		});

		if (newRoute) router.push(newRoute);
	}
}

return { __sfc: true,props, router, userStore, filterStore, languageStore, profileRoute, clicked, isEditorialLocale }
}

})